import { QueryClient } from "@tanstack/react-query";
import { WE_AGENT_REPORT_QUERY_KEY } from "./weAgentReportQueryApi";

export const weAgentReportQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export function prefetchWeAgentReport(date) {
  return weAgentReportQueryClient.prefetchQuery({
    queryKey: [WE_AGENT_REPORT_QUERY_KEY, date],
    queryFn: () =>
      import("./weAgentReportQueryApi").then((m) =>
        m.fetchWeAgentReportFromApi(date)
      ),
  });
}
